import { topicItems } from '@/mocks/cinema';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            大家都在讨论的热门话题，加入追剧聊天
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              className={`group flex items-center gap-2 px-5 py-3 rounded-full border transition-all duration-200 cursor-pointer ${
                topic.hot
                  ? 'bg-accent-500/10 border-accent-500/20 hover:bg-accent-500/20 text-accent-400'
                  : 'bg-background-100 border-background-200/30 hover:border-foreground-300/30 text-foreground-400'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-sm" />}
              <span className="text-sm font-medium whitespace-nowrap">{topic.name}</span>
              <span
                className={`text-xs whitespace-nowrap ${
                  topic.hot ? 'text-accent-500/70' : 'text-foreground-600'
                }`}
              >
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}